import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hubId", "contentVisibility"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets/icons/components/HubspotCertificationIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ExternalPortalOnly, { isInternalPortal } from '../../accounts/components/ExternalPortalOnly';
import { CaseIcon } from 'foundations-assets/icons/components/CaseIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const DEVREL_PORTAL_ID = 22047910;
export const ExternalLearningContentBanner = _ref => {
  let {
      hubId,
      contentVisibility
    } = _ref,
    viewProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isDevRelPortal = hubId === DEVREL_PORTAL_ID;
  const isInternalContent = contentVisibility === 'CREATOR_PORTAL_ONLY';
  const isExternalContent = !isInternalPortal(hubId) && !isInternalContent;
  if (isInternalContent) {
    return /*#__PURE__*/_jsx(View, Object.assign({}, viewProps, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        cursor: "pointer",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.externalContent.internalContentTooltip"
        }),
        children: /*#__PURE__*/_jsx(MediaObject, {
          align: "center",
          itemLeft: /*#__PURE__*/_jsx(CaseIcon, {
            color: "fill-accent-orange-default",
            size: "800"
          }),
          children: /*#__PURE__*/_jsx(Text, {
            textTransform: "uppercase",
            typography: "heading-50",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.externalContent.internalContentBanner"
            })
          })
        })
      })
    }));
  }
  if (isExternalContent) {
    return /*#__PURE__*/_jsx(View, Object.assign({}, viewProps, {
      children: /*#__PURE__*/_jsx(ExternalPortalOnly, {
        portalId: hubId,
        children: /*#__PURE__*/_jsx(Tooltip, {
          cursor: "pointer",
          title: isDevRelPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.externalContent.devRelTooltip"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.externalContent.externalCreatorTooltip"
          }),
          children: /*#__PURE__*/_jsx(MediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(HubspotCertificationIcon, {
              color: "fill-accent-orange-default",
              size: "800"
            }),
            children: /*#__PURE__*/_jsx(Text, {
              textTransform: "uppercase",
              typography: "heading-50",
              children: isDevRelPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.externalContent.devRelBanner"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.externalContent.externalCreatorBanner"
              })
            })
          })
        })
      })
    }));
  }
  return null;
};
export default ExternalLearningContentBanner;